import CrudGenerator from 'admin/pages/shared/CrudGenerator/CrudGenerator';
import { columns, formSchema } from './AccountConfig';
import UserAccount from './AccountsDetails';
import AccountService from './AccountService';
import './style.scss';

export default CrudGenerator({
    columns,
    formSchema,
    route: '/admin/accounts',
    entityName: {
        entityNamePlural: "Accounts",
        entityNameSingular: "Account"
    },
    getEntities: AccountService.getAccounts,
    editEntity: AccountService.editAccount,
    deleteEntities: AccountService.deleteAccounts,
    modalDetails: UserAccount,
    defaultShowAddEditExpandButton: false,
})